import { render, staticRenderFns } from "./PlacementsEndComponentCapabilitiesGroup.vue?vue&type=template&id=1e0300c6&"
import script from "./PlacementsEndComponentCapabilitiesGroup.vue?vue&type=script&lang=js&"
export * from "./PlacementsEndComponentCapabilitiesGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports